class MobileNav extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-nav-toggle]');
    this.panel = this.querySelector('[data-nav-panel]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.toggle());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  toggle() {
    const isOpen = this.getAttribute('data-open') === 'true';
    this.setAttribute('data-open', String(!isOpen));
    this.button.setAttribute('aria-expanded', String(!isOpen));
    document.body.classList.toggle('nav-open', !isOpen);
  }

  close() {
    this.setAttribute('data-open', 'false');
    this.button.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
    this.button.focus();
  }
}

class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = this.querySelector(`#${button.dataset.target}`);
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        this.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
        button.setAttribute('aria-current', 'true');
      });
    });
  }
}

class SortSelect extends HTMLElement {
  connectedCallback() {
    const select = this.querySelector('select');
    if (!select) return;
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  }
}

class QuantityInput extends HTMLElement {
  connectedCallback() {
    const input = this.querySelector('input');
    if (!input) return;
    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const next = Number(input.value) + Number(button.dataset.step);
        input.value = Math.max(Number(input.min || 0), next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
}

customElements.define('mobile-nav', MobileNav);
customElements.define('product-gallery', ProductGallery);
customElements.define('sort-select', SortSelect);
customElements.define('quantity-input', QuantityInput);

document.addEventListener('DOMContentLoaded', () => {
  const revealItems = document.querySelectorAll('[data-reveal]');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.14 });
  revealItems.forEach((item) => observer.observe(item));
});
